import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import CarouselCursos from "../common/CaruselCursos";
import { Recuadro } from "../common/Recuadro";

import "react-tabs/style/react-tabs.css";
import "./css/Nosotros.css";
import "./css/LandingNinos.css";

import persona from "../../images/ninos-Personaje-Banner-Principal-1.png";
import Microcursos from "../../images/Como-crear-una-caratula-e-indice-con-Word.jpg";
import cursoWord from "../../images/ninos-Banner-Curso-Word-270x180.png";
import cursoExcel from "../../images/ninos-Banner-Curso-Excel-270x180.png";
import cursoScratch from "../../images/ninos-Banner-Curso-Scratch-270x180.png";
import cursoPowerPoint from "../../images/ninos-Banner-Curso-PPT-Children-270x180.jpg";
import Beneficios from "../../images/02.png";
import excelLogo from "../../images/landing-Word-Objeto1.webp";
import wordLogo from "../../images/landing-Word-Objeto2.webp";
import powerPointLogo from "../../images/landing-Word-Objeto3.webp";
import windowsLogo from "../../images/landing-Word-Objeto4.webp";
import scratchLogo from "../../images/landing-Word-Objeto5.webp";
import personaje from "../../images/ninos-Personaje-02-1.png";
import personajeBanner from "../../images/ninos-Personaje-Banner-03-1.png";
import personajeBanner2 from "../../images/ninos-Personaje-Banner-04-1.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

const LandingNinos = () => {
  return (
    <>
      <Header />
      <main>
        <section className="primera-seccion-landing-ninos">
          <img src={persona} alt="fondo" loading="lazy" />
          <div className="primera-seccion-landing-ninos__texto">
            <span className="primera-seccion-landing-ninos__texto--aprende">¡APRENDÉ!</span>
            <span className="primera-seccion-landing-ninos__texto--so">
              SISTEMA OPERATIVO
            </span>
            <span className="primera-seccion-landing-ninos__texto--windows">WINDOWS</span>
            <p>¡Para niños, niñas y adolecentes! </p>
            <p className="primera-seccion-landing-ninos__texto--parrafo">
            De la mano de una de las mejores instituciones tecnológicas educativas de Latinoamerica, con profesores de amplia trayectoria pedagógica y Certificación en Microsoft Office Specialist.
            </p>
          </div>
        </section>

        <section className="segunda-seccion-landing-ninos">
       {/*  <a href="/">
            Además Incluye 
          </a>
          <hr /> */}
          <Recuadro
            source={cursoWord}
            imagenTexto={"Curso de Word"}
            texto={"Curso de Word"}
            direccion={"/"}
          />
          <Recuadro
            source={cursoExcel}
            imagenTexto={"Curso de Excel"}
            texto={"Curso de Excel"}
            direccion={"/"}
          />
          <Recuadro
            source={cursoScratch}
            imagenTexto={"Curso de Scratch"}
            texto={"Curso de Scratch"}
            direccion={"/"}
          />
          <Recuadro
            source={cursoPowerPoint}
            imagenTexto={"Curso de Powerpoint"}
            texto={"Curso de Powerpoint"}
            direccion={"/"}
          />
        </section>

        <section className="tercera-seccion-landing-ninos">
          <a href="/" alt="beneficios">
            ¡Aprende con todos estos súper beneficios!
          </a>
          <div className="beneficios-contenedor">
            <div className="beneficios-primera-parte">
              <ul>
                <li>
                  Cursos de word con vídeo tutoriales didácticos, prácticos y a
                  propio ritmo.
                </li>
                <li>
                  Los cursos son desarrollados por profesores certificados en
                  Microsoft Office Specialist y con didáctica educativa.
                </li>
                <li>
                  Los Cursos de word están divididos por niveles, word Inicial,
                  word Intermedio y word Avanzado.
                </li>
                <li>
                  Estos cursos están orientados a estudiantes de colegios y
                  universidades, empleados y emprendedores.
                </li>
              </ul>
            </div>
            <div className="beneficios-segunda-parte">
              <img src={Beneficios} alt="Imagen de Beneficios" loading="lazy" />
            </div>
            <div className="beneficios-tercera-parte">
              <ul>
                <li>
                  Los cursos pueden ser desarrollados desde una notebook, tablet
                  o a través de dispositivos móviles.
                </li>
                <li>
                  Asistencia y soporte de profesores en línea para consultas.
                </li>
                <li>Se otorgan certificados luego de culminar cada nivel.</li>
                <li>
                  Con una sola cuenta, pueden capacitarse toda la familia.
                </li>
              </ul>
              <a href="./acceder">
                <button type="button" title="Suscribirse">
                  ¡Inscribirse ahora!
                </button>
              </a>
            </div>
          </div>
        </section>

        <section className="cuarta-seccion-landing-ninos">
          <div className="cuarta-seccion__logos-cursos">
            <img src={excelLogo} alt="Logo de excel" />
            <img src={wordLogo} alt="Logo de Word" />
            <img src={powerPointLogo} alt="Logo de PowerPoint" />
            <img src={windowsLogo} alt="Logo de Windows" />
            <img src={scratchLogo} alt="Logo de Scratch" />
          </div>
          <div className="cuarta-seccion__foto">
            <img src={personaje} alt="Foto ilustrativa de mujer" />
          </div>
          <div className="cuarta-seccion__texto">
            <span>
              <b>Suscribiendote a los cursos de Windows</b>
            </span>
            <span>
              Te obsequamos los cursos de Microsoft scratchy y de Microsoft Word
            </span>
            <span>
              Para que los mas pequeños aprendan. Sin costos{" "}
              adicionales, desde la seguridad del hogar y como apoyo 
              pedagógico para el mejor desarrollo de sus tareas escolares
            </span>
            <button type="button">
              <a href="/">¡Inscribirse ahora!</a>
            </button>
          </div>
        </section>

        <section className="quinta-seccion-landing-ninos">
          <CarouselCursos category={"146"} title="Todos estos cursos, y para toda la familia" />
        </section>

        <section className="sexta-seccion-landing-ninos">
          <img src={personajeBanner} alt="Persona usando notebook" />
          <div className="sexta-seccion-landing-ninos__texto">
            <div className="sexta-seccion-landing-ninos__titulos">
              <span>
                Todos estos cursos, a un precio promocional por{" "}
                <span className="texto-verde">tiempo limitado</span>
              </span>
              <span>Precio normal: Suscripción anual de USD 120</span>
              <span>
                Precio promocional: Suscripción anual de <b>USD 59</b>
              </span>
            </div>
            <div className="sexta-seccion-landing-ninos__beneficios">
              <div className="sexta-seccion-landing-ninos__beneficios--primera-seccion">
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Suscripción anual de todos nuestros cursos de ofimática,
                  incluyendo Windows, Word, word, PowerPoint, Scratch.
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Cursos dirigidos a emprendedores, empleados, universitarios,
                  niños/as y adolescentes.
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Acceso a todos los cursos nuevos que se agregan o actualizan
                  periódicamente.
                </span>
              </div>
              <div className="sexta-seccion-landing-ninos__beneficios--segunda-seccion">
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Acceso a todos los recursos del Campus Virtual (videos,
                  presentaciones, documentos, planillas, ejercitarios, etc.).
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Docentes calificados que brindan asistencia en informar
                  permanentemente.
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Certificado digital al término de cada módulo.
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="icono-word-landing"
                  />
                  Con garantía de reembolso durante 60 días.
                </span>
              </div>
              <button>
                <a href="/">¡Inscribirse ahora!</a>
              </button>
            </div>
          </div>
        </section>

        <section className="septima-seccion-landing-ninos">
          <div>
            <span>¿Deseas conocer un poco más de nosotros?</span>
            <span>
              A través de nuestro apartado de Preguntas Frecuentes conocerás un
              poco más de las características de nuestros servicios educativos,
              y de nuestro Grupo Corporativo.
            </span>
            <div className="septima-seccion-landing-ninos__seccion-boton">
              <a href="/">
                <button type="button">¡Inscribirse ahora!</button>
              </a>
            </div>
          </div>
          <img src={personajeBanner2} alt="Foto ilustrativa de mujer" />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default LandingNinos;
